import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["domainInviteToggle"]
  }

  static get values() {
    return {
      url: String,
    }
  }

  toggle(event) {
    event.preventDefault()

    const isChecked = this.domainInviteToggleTarget.checked
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    fetch(this.urlValue, {
      method: "PUT",
      body: JSON.stringify({ team: { invite_by_domain: isChecked } }),
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
      },
      redirect: "manual",
    })
      .then((response) => {
        response.json().then((data) => {
          App.displayFlash(data.success ? "success" : "danger", data.message, "", 2000)
        })
      })
      .catch((error) => {
        console.error("Error:", error)
      })
  }
}
